const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/terms", "/terms"],
    exact: true,
    component: "Terms",
  },
  {
    path: ["/privacy", "/privacy"],
    exact: true,
    component: "Privacy",
  },
];

export default routes;
